import React, {Component} from 'react';
import {NavBar, SearchBar, Toast,Modal} from 'antd-mobile';
import {driverList,selectDrvier,resendorder} from "../../../../service/shuntService";
import {cityDriverList,selectCityDriver} from "../../../../service/cityService";
import {pickDriverList,orderSend} from "../../../../service/pickService";
import './style.less';
import {connect} from "react-redux";
import { read } from 'fs';
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Drivers extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            searchVal: '',
            showModal:false,
            dispatch:true,
            dispatchId:this.props.location.state.dispatchId,
            data: [],
            success:true,
            refuseWord:'',
            groupOrderId:""
        };
    }

    componentDidMount() {
        if(this.props.location.state.type === 'city'){
            this.getCityDriver('');
        }else if(this.props.location.state.type === 'pick'){
            this.getPickDriver('');
        }
        else{
            this.getDriverList('');
        }
    }
    getPickDriver=(value)=>{
        let params = {
            token: this.props.userInfo.token,
            data: {
                id: this.props.location.state.id
            }
        };
        console.log(params)
        pickDriverList(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                this.setState({data:res.data.data.list})
            } else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            } else {
                Toast.info(res.data.msg);
            }
        })
    }
  
    getCityDriver=(value)=>{
        let params = {
            token: this.props.userInfo.token,
            data: {
                id: this.props.location.state.id
            }
        };
        console.log(params)
        cityDriverList(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                this.setState({data:res.data.data})
            } else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            } else {
                Toast.info(res.data.msg);
            }
        })
    }
  
    //司机列表
    getDriverList=(value)=>{
        if(typeof this.state.dispatchId == 'object'){
            let params = {
                token: this.props.userInfo.token,
                data:this.state.dispatchId,
            };
            resendorder(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setState({data:res.data.data.driverListResults,groupOrderId:res.data.data.id})
                } else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                } else {
                    Toast.info(res.data.msg);
                }
            })
        }else{
            let params = {
                token: this.props.userInfo.token,
                "data":
                    {
                        "orderId":this.state.dispatchId,
                        "driverName":value,
                    }
            };
            driverList(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setState({data:res.data.data})
                } else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                } else {
                    Toast.info(res.data.msg);
                }
            })
        }

    };
    selectCityDriver = (res) =>{
        if(this.props.location.state.type === 'city'){
            var params = {
                token: this.props.userInfo.token,
                "data":
                {
                    "id":this.props.location.state.id,
                    "driverId": res.driverId,
                }
            };
            Toast.loading("正在加载",0);
            selectCityDriver(params).then((res) => {
                if (res.data.code === '0000') {
                    Toast.hide();
                    this.setState({
                        showModal:true,
                    })
                } else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                } else {
                    Toast.hide();
                    this.setState({
                        showModal:true,
                        success:false,
                        refuseWord:res.data.msg
                    })
                }
            })
        }else{
            var params = {
                token: this.props.userInfo.token,
                "data":
                {
                    "id":this.props.location.state.id,
                    "driverId": res.driverId,
                    "orderMold": 1,
                    "sendType": 2
                }
            };
            Toast.loading("正在加载",0);
            orderSend(params).then((res) => {
                if (res.data.code === '0000') {
                    Toast.hide();
                    this.setState({
                        showModal:true,
                    })
                } else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                } else {
                    Toast.hide();
                    this.setState({
                        showModal:true,
                        success:false,
                        refuseWord:res.data.msg
                    })
                }
            })
        }
        
       
    };
    selectDriver = (res) =>{
        let params = {
            token: this.props.userInfo.token,
            "data":
            {
                "orderId":typeof this.state.dispatchId == 'object' ? this.state.groupOrderId: this.state.dispatchId,
                "driverId": res.driverId,
            }
        };
        Toast.loading("正在加载",0);
        selectDrvier(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({
                    showModal:true,
                })
            } else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            } else {
                Toast.hide();
                this.setState({
                    showModal:true,
                    success:false,
                    refuseWord:res.data.msg
                })
            }
        })
    };
    goPage(){
        if(typeof this.state.dispatchId == 'object'){
            this.props.history.go(-2)
        }else{
            this.props.history.goBack()
        }
    }
    render() {
        return (
            <div className="driversScreen">
            <NavBar
                className="navBar"
                mode="light"
                icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.goPage()} />}
            >司机</NavBar>

                {/*<SearchBar
                    className="searchDriver"
                    value={this.state.searchVal}
                    placeholder="搜索司机"
                    onSubmit={value => this.getDriverList(value)}
                    onChange={value => this.setState({searchVal: value})}
                />*/}

                {
                    this.state.data.length ? (
                        <div className="driversList">
                            {
                                this.state.data.map((res, index) => (
                                    <div key={index} className="driverItem" onClick={()=>this.props.location.state.type === 'city'||this.props.location.state.type === 'pick' ? this.selectCityDriver(res) : this.selectDriver(res)}>
                                        <div><i className="icon iconfont iconmorensijitouxiang"></i></div>
                                        <div className="driverInfo">
                                            <div className="name">{res.driverName}<span>{res.carNum}</span></div>
                                            <div><i className="icon iconfont icondizhi"></i>暂无数据</div>
                                        </div>
                                       { /* <div className="carInfo">
                                            <span>待服务</span>
                                            <span>111</span>
                                        </div> */}
                                    </div>
                                ))
                            }
                        </div>
                    ) : (<div className="noData">暂无数据</div>)
                }
                <Modal
                    className="billViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '知道了', onPress: () => { this.setState({showModal:!this.state.showModal}); this.props.history.go(-2) } }]}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                    <div className="modalTitle">
                       {this.state.success ? <div className="success">派单成功!</div>:<div className="default">派单失败</div>}
                       {this.state.success ? <div>派单中，请关注后续情况！</div> : <div>{this.state.refuseWord}</div> }
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/Index/Drivers/index.js